






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































declare var window: any;
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
import { JobFilterWrapper } from '@/models/jobs/jobfilterwrapper';
import { JobFilter } from '@/models/jobs/jobfilter';
import { ATSJobListParams } from '../../models/jobs/atsjoblistparams';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import VueGoogleAutocomplete from 'vue-google-autocomplete';
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns';
import { MultiSelect, CheckBoxSelection } from '@syncfusion/ej2-dropdowns';
import rangeSlider from '../Commons/rangeSlider.vue';
import { CommonJobAlert } from '../../models/JobAlert/commonjobalert';
import { AlertConfigDetails } from '../../models/JobAlert/alertconfigdetails';
import { Geolocation } from '../../models/jobs/geolocation';
import { Latlong } from '../../models/jobs/latlong';
import { Locale } from '../../models/jobs/locale';
import { JobAlertUI } from '../../models/JobAlert/JobAlertUI';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { FilterModel } from './FilterModel';

import { JobSearchRequestPayload } from './JobSearchRequestPayload';
import { LocationInfo } from './LocationInfo';
import { SortCriteria } from '@/models/jobs/sortcriteria';
import ConfirmationModalV2 from '../Commons/ConfirmationModalV2.vue';
import { _ } from 'vue-underscore';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import { LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';
import { CommonJobAlertV2 } from '../../models/JobAlert/commonjobalertv2';
import { JobAlertConfigDetailsV2 } from '../../models/JobAlert/JobAlertConfigDetailsV2';
import { JobAlertV2 } from '../../models/JobAlert/JobAlertV2';
import { JobAlertLocationInfo } from '../JobAlert/JobAlertLocationInfo';
import { UserProfile } from '../../models/userdata/profile';
import Multiselect from 'vue-multiselect';
import NotificationPreference from '../MyProfile/NotificationPreference.vue';
import { NotificationPreferences } from '../../models/userdata/notificatonmap';
import RangeDropdown from '../Commons/rangeDropdown.vue';
import GDPR from '@/components/Registration/GDPR.vue';
MultiSelect.Inject(CheckBoxSelection);
Vue.use(MultiSelectPlugin);

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 3000,
});

declare var navigator: any;
const DEFAULT_RADIUS: number = 50;
const DEFAULT_RADIUS_MAX: number = 3250;

@Component({
  name: 'Searchbox',
  components: {
    VueGoogleAutocomplete,
    rangeSlider,
    Treeselect,
    Multiselect,
    RangeDropdown,
    GDPR,
  },
})
export default class SearchboxV2 extends Vue {
  @Prop() jobAlertId;
  @Prop() filtersData;
  @Prop() filterforJobalerts;

  $wlToastr: any;
  private jobListParams: ATSJobListParams = new ATSJobListParams();
  private jobListParamsXS: ATSJobListParams = new ATSJobListParams();
  private jobFilterWrapper: JobFilterWrapper = new JobFilterWrapper();
  private address: string = '';
  private map: string = '';
  private locationParser: string = '';
  private fields = { text: 'text', value: 'value' };
  private countries: string[] =
    vxm.configs.getGlobalConfigValue('LOCATION_JOB_FILTER_COUNTRIES') || [];
  private industry: number = 0;
  private shift: number = 0;
  private jobSkill: number = 0;
  private jobSkillArray: number[] = [];
  private candidatePlacementType: string = '';
  private jobAlertIsSms: boolean = false;
  private jobAlertIsEmail: boolean = true;
  private jobAlertIsPush: boolean = false;
  private userProfile: UserProfile = new UserProfile();
  private notificationPreferences : NotificationPreferences = new NotificationPreferences();
  private industryXL: any = [];
  private onInitialLoad: boolean = true;
  private shiftXL: any = '';
  private jobSkillXL: number = 0;
  private jobSkillXLArray: any = [];
  private candidatePlacementTypeXL: string = '';
  private isRemote: any = 3;
  private addressSearchText: string = '';
  private range: number =
    Number(window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.ClientConfigs.companyPreference.companyRadiusMax : vxm.jobs.BrandingInfo.COMPANY_RADIUS_MAX) || 10;
  private previousRadius: number =
    Number(window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.ClientConfigs.companyPreference.companyRadiusMax : vxm.jobs.BrandingInfo.COMPANY_RADIUS_MAX) || 10;
  private previousSalaryRangeValue: number = 0;
  private panelBodyVisibility: boolean = false;
  private isRangeSelectorDisabled: boolean = false;
  private locationType: string = '';
  private locShortName: string = '';
  private INACTIVE_SORT_COLOR_CODE: string = '#707070';
  private ACTIVE_SORT_COLOR_CODE: string = 'rgb(61, 145, 242)';
  private jobType: string = 'Job Type';
  private categories = [];
  private skillid: number = 0;
  private industryid: number = 0;
  private cityId: number = 0;
  private facilityTypes: any = [];
  private selectedDiscipline: any = '';
  private multiSelectFilter: any = [];
  private singleSelectFilter: any = [];
  private filterDataStore: any = [];
  private linkCopied: boolean = false;
  private salaryDefaultValue: string = '';
  private locationInfo = new LocationInfo();
  private sortCriteria = new SortCriteria();
  private keywords: string = '';
  private sortOptionsList: any = [];
  private JOB_POSTING_INITIAL_SORT = this.sortCriteria.sortField;
  private showEditJobAlertModal = false;
  private notificationEmail: boolean = false;
  private notificationSMS: boolean = false;
  private notificationPush: boolean = false;
  private notificationWhatsapp: boolean = false; 

  $refs!: {
    address_filter: HTMLFormElement;
    address_filter_2: HTMLFormElement;
  };
  private salaryPanelBodyVisibility: boolean = false;
  private salaryRange: number = 0;
  private filterData: any = '';

  private gdprObj = { marketingEmailFlag: false, tosEmailFlag: false };

  get showMapViewEnabled() {
    return vxm.configs.getGlobalConfigValue('ENABLE_MAP_VIEW_IN_FINDJOBS');
  }

  get showMapView() {
    return this.showMapViewEnabled && vxm.jobs.getMapViewMode;
  }

  toggleMapView() {
    vxm.jobs.setMapViewMode(!vxm.jobs.getMapViewMode);
  }
  toggleFilters() {
    var filters: any = document.getElementById('filtersForMobile');
    filters.style.display = 'block';
  }
  closePopUp() {
    var filters: any = document.getElementById('filtersForMobile');
    filters.style.display = 'none';
    var dropDown: any = document.getElementsByClassName('closeDropDown');
    for (var i = 0; i < dropDown.length; i++) {
      console.log(dropDown[i]);
      dropDown[i].style.display = 'none';
    }
  }
  multiselectOptions(filter) {
    return (filter.filterValues || []).map((opt) => ({
      value: opt.value,
      text: opt.label,
    }));
  }
  newState() {
    this.linkCopied = false;
    setTimeout(() => {
      var id: any = document.getElementById('NewJobAlertName');
      id.focus();
    }, 50);
  }
  get selectMode() {
    return 'CheckBox';
  }

  get appTheme() {
    return vxm.utility.AppTheme;
  }

  get appliedFilterRadius(): number {
    return vxm.jobs.FilterRadius;
  }

  get isJobAlertEnhancementEnabled(): boolean {
    return vxm.configs.getGlobalConfigValue('ENABLE_JOBALERT_V2');
  }

  get isRangeDropdownEnabled(): boolean {
    return vxm.configs.getGlobalConfigValue('ENABLE_JOB_LOCATION_DROPDOWN');
  }

  resetRangeField() {
    this.range = this.previousRadius;
    this.panelBodyVisibility = false;
  }

  resetSalaryRangeField() {
    this.salaryRange = this.previousSalaryRangeValue;
    this.salaryPanelBodyVisibility = false;
  }

  setRangeValue(val) {
    this.range = val;
    this.locationInfo.radius = val;
    vxm.jobs.setFilterRadius(this.range);
  }

  setSalaryRangeValue(event) {
    this.salaryRange = event.target.value;
  }

  get userLatitude(): number {
    return vxm.jobs.latitude;
  }
  notificationMap() {
    if (
      // !this.userProfile.notificationTypeMap.EMAIL
      !this.notificationPreferences.email && this.jobAlertIsEmail) {
      // this.userProfile.notificationTypeMap.EMAIL
      this.notificationPreferences.email = this.jobAlertIsEmail;

    }
    if (
      // !this.userProfile.notificationTypeMap.SMS 
      !this.notificationPreferences.sms && this.jobAlertIsSms) {
      // this.userProfile.notificationTypeMap.SMS
      this.notificationPreferences.sms = this.jobAlertIsSms;
    }
    if (
      // !this.userProfile.notificationTypeMap.PUSH_NOTIFICATION 
      !this.notificationPreferences.push && this.jobAlertIsPush
    ) {
      // this.userProfile.notificationTypeMap.PUSH_NOTIFICATION
      this.notificationPreferences.push = this.jobAlertIsPush;
    }
  }
  get userLongitude(): number {
    return vxm.jobs.longitude;
  }

  sortFindJobs(value: string) {
    this.sortCriteria.sortField = value;

    const selectedOption = this.sortOptionsList.filter(
      (option: any) => option.value === value,
    );
    this.sortCriteria.sortOrderAsc =
      selectedOption && selectedOption[0].sort === 'asc';

    this.filterJobs();
  }

  applyRadiusAndFilterJobs() {
    this.previousRadius = this.range;
    this.resetPageNumber();
    this.filterJobs();
  }

  applySalaryFilterAndFilterJobs(filter) {
    this.salaryPanelBodyVisibility = false;
    filter.defaultValue = this.salaryRange;
    this.previousSalaryRangeValue = this.salaryRange;
    this.resetPageNumber();
    this.filterJobs();
  }

  setFilterValuesFromSlugUrl() {
    let slugUrl = this.filterDataStore.reduce((acc, filter) => {
      if (filter.displayType === 'location') {
        return acc + 'within-(.*)-miles-from-(.*)-location-';
      }
      if (filter.displayType === 'range') {
        return acc;
      }
      return acc + '(.*)-' + filter.slugAlias + '-';
    }, '');
    slugUrl += '(.*)-order';
    const slugRegex = new RegExp(slugUrl);
    const filterUrl = this.$route.params.filterUrl + '-';
    const matchedItems = filterUrl.match(slugRegex);
    if (matchedItems) {
      this.filterDataStore.forEach((filter, index) => {
        if (filter.displayType === 'location') {
          filter.defaultValue =
            matchedItems[index + 2] === 'any'
              ? ''
              : matchedItems[index + 2].replace(/-/g, ' ');
          return;
        }
        if (filter.displayType === 'range') {
          filter.defaultValue =
            matchedItems[index] === 'any' ? '' : matchedItems[index];
          this.locationInfo.radius = Number(matchedItems[index]);
          this.range = Number(matchedItems[index]);
          this.previousRadius = this.range;
          return;
        }
        if (filter.displayType === 'select') {
          var indexNumber = index;
          if (matchedItems[index + 1] !== 'any') {
            const selectedItemIndex = filter.displayList.findIndex(
              (item) =>
                item.toLowerCase().replace(/ |\//g, '-') ===
                matchedItems[index + 1],
            );
            filter.defaultValue = filter.valueList[selectedItemIndex];
            this.singleSelectFilter[indexNumber] = {
              value: filter.valueList[selectedItemIndex],
              label: filter.displayList[selectedItemIndex],
              sortOrderAsc: null,
              subcategories: null,
            };
            return;
          } else if (filter.fieldType === 2) {
            if (!filter.defaultValue) {
              filter.defaultValue = this.JOB_POSTING_INITIAL_SORT;
            }
            return;
          }
        }
        if (this.isMultiSelectFilter(filter.displayType)) {
          var indexNumber = index;
          this.multiSelectFilter[indexNumber] = [];
          if (matchedItems[index + 1] !== 'any') {
            filter.defaultValue = [];
            matchedItems[index + 1].split('_').forEach((item) => {
              if (this.isCategoryFilter(filter.slugAlias)) {
                let category = this.getCategoryByProperty(
                  filter,
                  'label',
                  item,
                );
                if (category.length > 0) {
                  let ids = this.getCategoryAndSubcategoryIds(category);
                  ids.forEach((id) => {
                    filter.defaultValue.push(id);
                  });
                }
              } else {
                const index = filter.displayList.findIndex(
                  (option) =>
                    option.toLowerCase().replace(/ |\//g, '-') === item,
                );
                if (index >= 0) {
                  filter.defaultValue.push(filter.valueList[index]);
                  this.multiSelectFilter[indexNumber].push({
                    value: filter.valueList[index],
                    text: filter.displayList[index],
                  });
                }
              }
            });
          }
          return;
        }
        if (filter.displayType === 'text') {
          filter.defaultValue =
            matchedItems[index + 1] === 'any'
              ? ''
              : decodeURIComponent(matchedItems[index + 1]);
          return;
        }
        if (filter.displayType === 'salaryrange') {
          filter.defaultValue = matchedItems[index + 1];
        }
        filter.defaultValue =
          matchedItems[index + 1] === 'any' ? '' : matchedItems[index + 1];
      });

      let sortFilter = this.filterDataStore.find(
        (filter) => filter.fieldType === 2,
      );
      if (undefined !== sortFilter) {
        this.sortCriteria = {
          sortOrderAsc: matchedItems[matchedItems.length - 1] === 'ascending',
          sortField: sortFilter.defaultValue,
        };
      }
    }
  }

  filterJobs(seoFreindlyUrl = false) {
    this.closePopUp();
    this.panelBodyVisibility = false;
    this.salaryPanelBodyVisibility = false;
    var previousRoute = this.$route.name;
    !seoFreindlyUrl && this.prepareSlugURL();
    var currentRoute = this.$route.name;
    if (!previousRoute && currentRoute === 'FindjobsByFilter') {
      vxm.utility.setPreventFilterMetaDataAPI(true);
      return;
    }
    const reqPayload: JobSearchRequestPayload = this.prepareRequestPayload();
    vxm.users.Rudderstack.trackEvent("Job Search Completed", {
      jobSearchlatitudeInfo: vxm.jobs.JobListParams.geoLocation.latLong.latitude ? vxm.jobs.JobListParams.geoLocation.latLong.latitude : " ",
      jobSearchLongitudeInfo: vxm.jobs.JobListParams.geoLocation.latLong.longitude ? vxm.jobs.JobListParams.geoLocation.latLong.longitude : " ",
      jobSortingCriteria: vxm.jobs.JobListParams.sortCriteria.sortOrderAsc,
      jobSearchRadius: vxm.jobs.JobLocationInfo.radius,
      jobSearchText : this.searchText
    });
    if(reqPayload.sortCriteria.sortField === "JobPosting.jobPublishDTTM desc"){
      reqPayload.sortCriteria.sortField = "JobPosting.jobPublishDTTM";
    }
    vxm.jobs.setJobListParamsV2(reqPayload);
    if(!vxm.jobs.JobListParams.geoLocation.latLong.latitude && reqPayload.locationInfo.latLong){
      vxm.jobs.JobListParams.geoLocation.latLong = reqPayload.locationInfo.latLong;
    }

    let copy = JSON.parse(JSON.stringify(reqPayload));
    const respPromise: any = vxm.jobs.reloadJobsV2(copy);

    const vm = this;
    Promise.all([respPromise]).then(
      (values) => {
        const isFilterApplied =
          reqPayload.jobParamRequests.length > 0 ||
          (reqPayload.locationInfo &&
            reqPayload.locationInfo.latLong &&
            Boolean(reqPayload.locationInfo.latLong.latitude) &&
            Boolean(reqPayload.locationInfo.locShortName));
        vm.showJobAlertV2Card = isFilterApplied;
        vm.showJobAlertcard = isFilterApplied;
        vm.commonJobAlert.jobAlert.id = 0;
        if (values[0].errorCode === '1111') {
          vm.$wlToastr('info', values[0].errorMessage);
        }
      },
      (err) => {},
    );

    if (this.isJobAlertEnhancementEnabled && this.showJobAlertV2Card) {
      this.showJobAlertcard = true;
    } else if (this.keywords != '' || this.addressSearchText != '') {
      this.showJobAlertcard = true;
    } else {
      this.showJobAlertcard = false;
    }
    this.toggleJobAlertLink();
  }
  @Watch('$route' , { immediate: true })
  onRouteChange() {
      if ((this.addressSearchText || this.locationInfo.location)
        && this.previousRadius === this.maximumSearchDistance){
        this.range = DEFAULT_RADIUS;
        this.previousRadius = DEFAULT_RADIUS;
      }
  }
  get currency() {
    return (
      vxm.configs.getCompanyPreference('CURRENCY', 'companyCurrency') || '$'
    );
  }

  getSalaryRangeLabel(filter) {
    return `${filter.label}: ${vxm.configs.getCompanyPreference(
      'CURRENCY',
      'companyCurrency',
    )}${this.salaryRange}+`;
  }

  getCategoryByProperty(filter, propertyToFind, valueToFind) {
    let displayList = filter.displayList;
    const isLookingString = typeof valueToFind === 'string';
    valueToFind = isLookingString ? valueToFind.toLowerCase() : valueToFind;

    let category = displayList.filter((c) => {
      let propValue = c[propertyToFind];
      if(!isLookingString)
      return (
        (isLookingString ? propValue.toLowerCase() : Number(propValue)) === valueToFind
      );
    });

    if (category.length == 0) {
      //find bys subcategory
      displayList.filter((c) => {
        if (c.children) {
          return c.children.forEach((sc) => {
            let propValue = sc[propertyToFind];
            if (
              (isLookingString ? propValue.toLowerCase() : propValue) ===
              valueToFind
            ) {
              category.push(sc);
              return;
            }
          });
        }
      });
    }
    return category;
  }

  getCategoryAndSubcategoryIds(categories) {
    let ids: any = [];
    categories.forEach((c) => {
      ids.push(c.id);

      if (c.children) {
        c.children.forEach((sc) => {
          ids.push(sc.id);
        });
      }
    });

    return ids;
  }

  prepareSlugURL() {
    let route = ``;
    this.filterDataStore.forEach((element) => {
      let filterValue = 'any';
      const valueList = element.valueList;
      const displayList = element.displayList;
      if (element.displayType === 'select' && element.defaultValue) {
        let index = valueList.indexOf(element.defaultValue);
        filterValue = (displayList && displayList[index]) || 'any';
      } else if (
        this.isMultiSelectFilter(element.displayType) &&
        element.defaultValue
      ) {
        let displayValues: string[] = [];
        element.defaultValue.forEach((value) => {
          if (this.isCategoryFilter(element.slugAlias)) {
            //find by category
            let category = this.getCategoryByProperty(
              element,
              'id',
              parseInt(value),
            );

            if (category.length > 0) {
              displayValues.push(category[0].label);
            }
          } else {
            const index = valueList.indexOf(value);
            if (index >= 0) displayValues.push(displayList[index]);
          }
        });
        filterValue = displayValues.length
          ? displayValues
              .join('_')
              .toLowerCase()
              .replace(/ |\//g, '-')
          : 'any';
      } else if (element.displayType === 'location') {
        if (vxm.jobs.FilterForJobAlerts) {
          this.locationInfo.radius = vxm.jobs.JobLocationInfo.radius!;
          if (vxm.jobs.JobLocationInfo.radius > 0) {
            this.range = this.locationInfo.radius!;
            this.previousRadius = this.range;
          }
          if (
            vxm.jobs.JobLocationInfo.location != null &&
            vxm.jobs.JobLocationInfo.location.length > 0
          ) {
            this.locationParser = '';
            this.locationInfo.location = vxm.jobs.JobLocationInfo.location;
            this.addressSearchText = vxm.jobs.JobLocationInfo.location;
            this.locationInfo.radius = vxm.jobs.JobLocationInfo.radius;
            this.locationInfo.location = vxm.jobs.JobLocationInfo.location;
            this.locationInfo.locShortName =
              vxm.jobs.JobLocationInfo.locShortName;
            this.locationInfo.latLong.latitude =
              vxm.jobs.JobLocationInfo.latLong.latitude;
            this.locationInfo.latLong.longitude =
              vxm.jobs.JobLocationInfo.latLong.longitude;
            this.locationInfo.locationType =
              vxm.jobs.JobLocationInfo.locationType;
            this.locationParser = this.addressSearchText;
          }
        }

        filterValue =
          (this.locationInfo.radius || this.maximumSearchDistance) + '';
        route += `within-${filterValue}-miles-`;
        const location = this.locationInfo.location
          ? this.locationInfo.location
          : 'any';
        filterValue = `from-${location}`;
        element.slugAlias = 'location';
        this.previousRadius = this.range;
      } else if (element.displayType === 'text' && element.defaultValue) {
        filterValue = element.defaultValue;
      } else if (
        element.displayType === 'salaryrange' &&
        element.defaultValue
      ) {
        element.defaultValue = this.salaryRange;
        this.previousSalaryRangeValue = element.defaultValue;
        filterValue = element.defaultValue + '+';
      }
      if (element.displayType !== 'range' && element.displayType !== 'text') {
        filterValue = filterValue.toLowerCase().replace(/ |\//g, '-');
        route += `${filterValue}-${element.slugAlias}-`;
      } else if (element.displayType === 'text') {
        filterValue = encodeURIComponent(filterValue);
        route += `${filterValue}-${element.slugAlias}-`;
      }
    });
    vxm.jobs.setFilterForJobAlerts(false);
    vxm.jobs.setJobAlertLocationInfo('');
    route += this.sortCriteria.sortOrderAsc
      ? 'ascending-order'
      : 'descending-order';
    this.$router.push({ path: `/jobs-by-filter/${route}` });
  }

  prepareRequestPayload(): JobSearchRequestPayload {
    let jobSearchRequestPayload: JobSearchRequestPayload =
      vxm.jobs.JobListParamsV2; //using this object to keep the previous values, (because is possible that "Jobs per Page" change the default value)
    let filterPayload: FilterModel[] = [];

    this.filterDataStore.forEach((element) => {
      if (element.name && element.name === 'JobPosting.searchField') {
        this.keywords = element.defaultValue;
      }
      if (element.fieldType === 1) {
        let filterValue;
        if (this.isCategoryFilter(element.slugAlias)) {
          filterValue =
            element.defaultValue && element.defaultValue.length
              ? JSON.stringify({ categoryIds: element.defaultValue })
              : null;
        } else {
          if (element.displayType == 'salaryrange' && this.onInitialLoad) {
            filterValue = this.salaryDefaultValue;
            this.onInitialLoad = false;
          } else {
            filterValue = element.defaultValue
              ? Array.isArray(element.defaultValue)
                ? element.defaultValue.toString()
                : element.defaultValue
              : null;
          }
        }
        let obj: FilterModel = {
          name: element.name,
          displayType: element.displayType,
          fieldType: element.fieldType,
          value: filterValue,
          slugAlias : element.slugAlias,
        };
        if (filterValue && this.includeInParams(element.name)) {
          filterPayload.push(obj);
        }
      }
    });

    jobSearchRequestPayload.jobParamRequests = filterPayload;
    if (!this.locationInfo.location) {
      this.locationInfo.latLong.latitude = vxm.jobs.latitude;
      this.locationInfo.latLong.longitude = vxm.jobs.longitude;
      this.locationInfo.locShortName = '';
      this.locationInfo.locationType = '';
    } else if (
      this.locationInfo.latLong.latitude === vxm.jobs.latitude &&
      this.locationInfo.latLong.longitude === vxm.jobs.longitude
    ) {
      this.onNoResults();
    }
    jobSearchRequestPayload.locationInfo = this.locationInfo;
    if (this.sortCriteria && !this.sortCriteria.sortField) {
      this.sortCriteria.sortField = this.JOB_POSTING_INITIAL_SORT;
    }
    jobSearchRequestPayload.sortCriteria = this.sortCriteria;
    jobSearchRequestPayload.locationInfo.radius = this.range;
    vxm.jobs.setFilterRadius(this.range);
    return jobSearchRequestPayload;
  }
  async onValueSelected(event, filter) {
    try {
      if (
        filter.name &&
        filter.name === 'IndustryVertical.industryVerticalId'
      ) {
        const selectedIndustries = event ? event.value : [];
        let filteredSkills: any[] = [];
        if (selectedIndustries && selectedIndustries.length > 0) {
          const skillDataResponse = await vxm.jobs.fetchSkillsData(
            selectedIndustries,
          );
          if (skillDataResponse && skillDataResponse.meta.success) {
            const skillsData = skillDataResponse.data;
            const valueList =
              typeof skillsData.valueList === 'string'
                ? skillsData.valueList.split(/\s*,\s*/)
                : skillsData.valueList;
            const displayList =
              typeof skillsData.displayList === 'string'
                ? skillsData.displayList.split(/\s*,\s*/)
                : skillsData.displayList;
            let size = valueList ? valueList.length : 0;
            for (let i = 0; i < size; i++) {
              filteredSkills.push({
                text: displayList[i],
                value: valueList[i],
              });
            }
          }
        } else {
          let skillFilterObj = this.filterDataStore.filter(
            (element) =>
              element.name &&
              element.name.toLowerCase() ===
                'skillType.skillTypeId'.toLowerCase(),
          );
          if (skillFilterObj && skillFilterObj.length > 0) {
            const skillFilter = skillFilterObj[0];
            const size = skillFilter.valueList.length;
            for (let i = 0; i < size; i++) {
              filteredSkills.push({
                text: skillFilter.displayList[i],
                value: skillFilter.valueList[i],
              });
            }
          }
        }

        const filterDataStoreUpdated = this.filterDataStore.map((element) => {
          if (
            element.name &&
            element.name.toLowerCase() ===
              'skillType.skillTypeId'.toLowerCase() &&
            element.options
          ) {
            element.options = filteredSkills;
            element.defaultValue = this.setDefaultSkillFilterValues(
              element.defaultValue,
              filteredSkills,
            );
          }
          return element;
        });
        this.filterDataStore = filterDataStoreUpdated;
      }
      //reset the pagination
      this.resetPageNumber();
      this.filterJobs();
    } catch (ex) {}
  }

  setDefaultSkillFilterValues(defaultValue: any, filteredSkills: any[]): any {
    if (
      Array.isArray(filteredSkills) &&
      filteredSkills.length > 0 &&
      defaultValue &&
      Array.isArray(defaultValue) &&
      defaultValue.length > 0
    ) {
      let skillIds: string[] = filteredSkills.map((skillObj) => skillObj.value);
      var skillSet = new Set(skillIds);
      return defaultValue.filter((value) => skillSet.has(value));
    }
    return [];
  }

  get getRange() {
    return this.range;
  }

  removeParentCategoryIds(categoriesId) {
    const formattedCategories = categoriesId.map((categoryId) => {
      if (
        vxm.skills.expertiseDataWrapper.categories.find(
          (category) =>
            category.categoryId === categoryId && !category.parentCategoryId,
        )
      ) {
        const childCategoryIds = vxm.skills.expertiseDataWrapper.categories
          .filter((category) => categoryId === category.parentCategoryId)
          .map((category) => {
            return category.categoryId;
          });
        return childCategoryIds.length ? childCategoryIds : categoryId;
      }
      return categoryId;
    });
    return formattedCategories.flat();
  }

  setLocationFieldLabelAndValue(filter) {
    setTimeout(
      (this_) => {
        if (this_.locationInfo.location) {
          this_.addressSearchText = this_.locationInfo.location;
        }
        if (
          this_.addressSearchText &&
          this_.$refs.address_filter &&
          this_.$refs.address_filter.length > 0
        ) {
          this_.$refs.address_filter[0].update(this_.addressSearchText);
        }
        if (
          this_.addressSearchText &&
          this_.$refs.address_filter_2 &&
          this_.$refs.address_filter_2.length > 0
        ) {
          this_.$refs.address_filter_2[0].update(this_.addressSearchText);
        }
      },
      50,
      this,
    );
    return filter.label;
  }

  getAddressData(addressData, placeResultData, id) {
    this.locationInfo.latLong.latitude = addressData.latitude;
    this.locationInfo.latLong.longitude = addressData.longitude;

    this.jobListParams.geoLocation.latLong.latitude = addressData.latitude;
    this.jobListParams.geoLocation.latLong.longitude = addressData.longitude;
    this.jobListParams.geoLocation.requestPref = 'LATLONG';
    this.jobListParams.location = placeResultData.formatted_address;
    if (
      placeResultData.types[0] === 'administrative_area_level_1' ||
      placeResultData.types[0] === 'country'
    ) {
      this.isRangeSelectorDisabled = true;
      this.panelBodyVisibility = false;
    } else {
      this.isRangeSelectorDisabled = false;
    }

    this.locationInfo.locationType = placeResultData.types[0];
    this.locationType = placeResultData.types[0];
    this.locShortName = placeResultData.address_components[0].short_name;
    this.locationInfo.locShortName = this.locShortName;
    if (
      placeResultData.types[0] === 'locality' &&
      this.range === this.maximumSearchDistance
    ) {
      this.range = 50;
      this.previousRadius = 50;
    }
    this.locationInfo.radius = this.range;
  }

  getAddressDataXS(addressData, placeResultData, id) {
    this.jobListParamsXS.geoLocation.latLong.latitude = addressData.latitude;
    this.jobListParamsXS.geoLocation.latLong.longitude = addressData.longitude;
    this.jobListParamsXS.geoLocation.requestPref = 'LATLONG';
    this.jobListParamsXS.location =
      addressData.route +
      ', ' +
      addressData.locality +
      ', ' +
      addressData.administrative_area_level_1;
  }

  showRangeBody() {
    this.panelBodyVisibility = true;
  }

  showSalaryRangeBody() {
    this.salaryPanelBodyVisibility = true;
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get jfWrapper() {
    return vxm.jobs.jfWrapper;
  }

  get candidatePlacementTypes(): JobFilter[] {
    return vxm.jobs.jfWrapper.candidatePlacementTypes;
  }

  get sortingOptions(): JobFilter[] {
    return vxm.jobs.jfWrapper.sortingOptions;
  }

  get industryVerticals(): JobFilter[] {
    return vxm.jobs.jfWrapper.industryVerticals;
  }

  get datePosted(): JobFilter[] {
    return vxm.jobs.jfWrapper.datePosted;
  }

  get jobSkills(): JobFilter[] {
    let skillDropdownValues: JobFilter[] = vxm.jobs.jfWrapper.jobSkills;
    if (!this.industryXL || (this.industryXL && this.industryXL.length == 0)) {
      return skillDropdownValues;
    }
    let industries = new Set();
    if (Array.isArray(this.industryXL)) {
      industries = new Set(this.industryXL);
    } else {
      industries = new Set([this.industryXL]);
    }
    const industryid = parseInt(this.industryXL + '');
    let jobSkillxlArr = this.lodash.cloneDeep(this.jobSkillXLArray);
    jobSkillxlArr = jobSkillxlArr.filter((skillId) => {
      const size = skillDropdownValues.length;
      for (let i = 0; i < size; i++) {
        let skillEntry: JobFilter = skillDropdownValues[i];
        let skillTypeId = parseInt(skillEntry.value);
        let referenceId = parseInt(skillEntry.reference);
        if (
          skillId == skillTypeId &&
          (industries.has(referenceId) || industries.has(referenceId + ''))
        ) {
          return true;
        }
      }
      return false;
    });
    let vl = skillDropdownValues.filter((skillEntry) => {
      let referenceId = parseInt(skillEntry.reference);
      if (industries.has(referenceId) || industries.has(referenceId + '')) {
        return true;
      }
      return false;
    });
    this.jobSkillXLArray = this.lodash.cloneDeep(jobSkillxlArr);
    return vl;
  }

  onAddressTextChange(text: string) {
    this.addressSearchText = text;
    this.locationInfo.location = text;
    if (!text) {
      this.jobListParams.geoLocation.latLong = {};
      this.jobListParams.location = '';
      this.range = this.maximumSearchDistance;
      this.previousRadius = this.maximumSearchDistance;
       // Enable the range selector since the location is cleared
      this.isRangeSelectorDisabled = false;
    }
  }

  onNoResults() {
    this.$wlToastr(
      'info',
      `Look like you haven’t selected a location from the suggested list. Please select a location to find jobs near <b> ${
        this.locationInfo.location
      }</b>.`,
    );
  }

  async setLocationInfoFromSlugUrl() {
    let locationText = this.filterDataStore.find(
      (filter) => filter.displayType === 'location',
    );
    if (locationText) {
      locationText = locationText.defaultValue;
      let response = {
        latitude: 0,
        longitude: 0,
        locationType: '',
        locShortName: '',
      };
      if (locationText) {
        console.log('value of location text >> ' + locationText);
        console.log('type of location text >> ' + typeof locationText);
        response = await vxm.utility.getLatitudeLongitude({
          locationText,
        });
      }

      if (response && response.latitude) {
        this.locationInfo = {
          latLong: {
            latitude: response.latitude,
            longitude: response.longitude,
          },
          locShortName: response.locShortName,
          location: locationText,
          locationType: response.locationType,
          radius: Number(this.range),
        };
        if(!this.jobListParams.geoLocation.latLong.latitude){
          this.jobListParams.geoLocation.latLong.latitude = response.latitude;
        this.jobListParams.geoLocation.latLong.longitude = response.longitude;
        }
        this.isRangeSelectorDisabled =
          this.locationInfo.locationType === 'country' ||
          this.locationInfo.locationType === 'administrative_area_level_1';
      }
      if (this.$refs.address_filter) {
        const addressFilter = this.$refs.address_filter[0] as HTMLFormElement;
        addressFilter.update(locationText);
      }
      if (this.$refs.address_filter_2) {
        const addressFilter2 = this.$refs
          .address_filter_2[0] as HTMLFormElement;
        addressFilter2.update(locationText);
      }
    }
  }

  get minimumSearchDistance() {
    return vxm.jobs.getCompanyRadiusMin
      ? parseInt(vxm.jobs.getCompanyRadiusMin)
      : 5;
  }

  get maximumSearchDistance() {
    return vxm.jobs.getCompanyRadiusMax
      ? parseInt(vxm.jobs.getCompanyRadiusMax)
      : 3250;
  }

  notificationAssign() {
    this.notificationEmail =  this.notificationPreferences.email;
    // this.userProfile.notificationTypeMap.EMAIL;
    this.notificationSMS = this.notificationPreferences.sms;
    // this.userProfile.notificationTypeMap.SMS;
    this.notificationPush = this.notificationPreferences.push;
    //this.userProfile.notificationTypeMap.PUSH_NOTIFICATION;
    this.notificationWhatsapp =this.notificationPreferences.whatsapp;
    //  this.userProfile.notificationTypeMap.WHATSAPP;
  }

  async mounted() {
    // this.userProfile = vxm.users.myUserProfile;
    this.notificationPreferences = vxm.notificationpreference.userNotificationPreferences;
    this.notificationAssign();
    if (this.jobAlertId || this.getJobAlertId) {
      vxm.jobs
        .getJobAlertV2(this.jobAlertId || this.getJobAlertId)
        .then((jobAlert) => {
          if (jobAlert) {
            this.newLink(jobAlert);
          }
          this.initSearchComponent();
        });
    } else {
      this.initSearchComponent();
    }
  }

  async initSearchComponent() {
    this.formatFilterData();
    if (this.$route.params.filterUrl) {
      this.setFilterValuesFromSlugUrl();
      await this.setLocationInfoFromSlugUrl();
    }

    this.showJobAlertcard = !(
      this.locationInfo.location == '' && this.addressSearchText == ''
    );
    //  removed job alert calls in findjobs page
    // if (vxm.users.isLoggedIn) {
    //   const respPromise: any = vxm.jobs.getJobAlerts(
    //     vxm.users.myUserProfile.email,
    //   );
    //   Promise.all([respPromise]).then(
    //     (response) => {
    //       if (response) {
    //         vxm.jobs.setJobAlerts(response[0].jobAlerts);
    //       }
    //     },
    //     (err) => {},
    //   );
    // }
    if (this.isSeoFriendlyUrl) {
      if (this.$route.params.SkillID) {
        this.filterDataStore = this.filterDataStore.map((filter) => {
          if (filter.name === 'SkillType.skillTypeId') {
            filter.defaultValue = [this.$route.params.SkillID];
          }
          return filter;
        });
      }
      if (this.$route.params.IndustryID) {
        this.filterDataStore = this.filterDataStore.map((filter) => {
          if (filter.name === 'IndustryVertical.industryVerticalId') {
            filter.defaultValue = [this.$route.params.IndustryID];
          }
          return filter;
        });
      }
      if (this.$route.params.location) {
        this.filterDataStore.find(
          (filter) => filter.displayType === 'location',
        ).defaultValue = this.$route.params.location;
        await this.setLocationInfoFromSlugUrl();
        this.locationInfo.radius = 10;
        this.range = 10;
      }
    }

    // Avoid applying filters twice when opening for very first time.
    if (!(this.jobAlertId || this.getJobAlertId)) {
      this.filterJobs(this.isSeoFriendlyUrl);
    }

    document.addEventListener('click', (event: any) => {
      if (!(event && event.target && event.target.closest('#accordion3'))) {
        this.resetSalaryRangeField();
      }
      if (!(event && event.target && event.target.closest('#accordion'))) {
        this.resetRangeField();
      }
    });
  }

  get getJobAlertId() {
    return this.$route.query.jobAlertId;
  }

  getTranslatedValue(key, defaultValue) {
    const lang = this.$cookies.get('userLang') || 'en';
    if (lang === 'en') return defaultValue;
    const label = this.$t(key).toString();
    return label.indexOf(key) >= 0 ? defaultValue || label : label;
  }

  async newLink(jobalert: any) {
    this.locationInfo = new JobAlertLocationInfo();
    var appliedFilters = jobalert.jobAlertConfigDetails.jobParamRequests;
    var locationInfo = jobalert.jobAlertConfigDetails.locationInfo;
    var sortInfo = jobalert.jobAlertConfigDetails.sortCriteria;
    vxm.jobs.setFilterForJobAlerts(true);
    const filterDataResponse = await vxm.jobs.fetchFiltersData();
    this.filterData =
      filterDataResponse && filterDataResponse.data
        ? filterDataResponse.data
        : null;

    if (this.filterData && this.filterData.jobFilterMetaDataVOList) {
      this.filterData.jobFilterMetaDataVOList.forEach((filter) => {
        filter.label = filter.label;
      });
    }

    if (locationInfo != null) {
      var radius = (this.range = locationInfo.radius);
      var location = locationInfo.location;
      this.locationInfo.radius = locationInfo.radius;
      this.locationInfo.location = locationInfo.location;
    }

    var sortValue = this.JOB_POSTING_INITIAL_SORT;
    var sortOrder: boolean = false;

    if (sortInfo != null) {
      sortValue = sortInfo.sortField;
      sortOrder = sortInfo.sortOrderAsc;
    }

    this.sortCriteria.sortField = sortValue;
    this.sortCriteria.sortOrderAsc = sortOrder;

    if (location != null && location.length > 0) {
      (this.locationInfo.locShortName = locationInfo.locShortName),
        (this.locationInfo.latLong.latitude = locationInfo.latLong.latitude);
      this.locationInfo.latLong.longitude = locationInfo.latLong.longitude;
      this.locationInfo.locationType = locationInfo.locationType;
    }
    if (appliedFilters.length > 0) {
      appliedFilters.forEach((appliedFilter) => {
        this.setFilterValues(appliedFilter, radius, location, sortValue);
      });
    } else {
      this.filterData.jobFilterMetaDataVOList.forEach((filter) => {
        if (filter.name === 'JobPosting.SortCriteria') {
          filter.defaultValue = sortValue;
        } else if (
          filter.displayType == 'select' &&
          !filter.hasOwnProperty('defaultValue')
        ) {
          filter.defaultValue = '';
        }
      });
    }
    //this.$router.push({ name: 'Findjobs' });
    let jobListParamsV2: JobSearchRequestPayload = new JobSearchRequestPayload();
    jobListParamsV2.jobParamRequests = appliedFilters.map((filter) => ({
      name: filter.name,
      value: filter.value,
      displayType: filter.displayType,
      fieldType: filter.fieldType,
    }));
    jobListParamsV2.locationInfo = locationInfo;
    vxm.jobs.setJobListParamsV2(jobListParamsV2);
    vxm.jobs.setJobAlertLocationInfo(this.locationInfo);
    vxm.jobs.setJobAlertFilterURL(this.filterData);
    this.sortFindJobs(sortValue);
  }

  setFilterValues(appliedFilter, radius, location, sortValue) {
    const filters = this.filtersData.jobFilterMetaDataVOList;
    const filter = filters.forEach((filter) => {
      if (appliedFilter.name == filter.name) {
        if (
          appliedFilter.displayType == 'salaryrange' ||
          appliedFilter.displayType == 'text' ||
          appliedFilter.displayType == 'select'
        ) {
          filter.defaultValue = appliedFilter.value;
        } else if (appliedFilter.displayType == 'range') {
          if (radius != '') {
            filter.defaultValue = radius;
            this.locationInfo.radius = radius;
          }
        } else if (appliedFilter.displayType == 'multi-select') {
          filter.defaultValue = appliedFilter.value.split(',');
        }
      } else if (
        filter.displayType == 'select' &&
        !filter.hasOwnProperty('defaultValue')
      ) {
        filter.defaultValue = '';
      }
    });

    const locationFilter = filters.find(
      (filter) => filter.displayType === 'location',
    );
    if (locationFilter) {
      locationFilter.defaultValue = location;
    }

    const sortFilter = filters.find(
      (filter) => filter.name === 'JobPosting.SortCriteria',
    );
    if (sortFilter) {
      sortFilter.defaultValue = sortValue;
    }
  }

  minimumFilterValue(filter: any) {
    return filter.extraConfig.min || 0;
  }

  maximumFilterValue(filter: any) {
    return filter.extraConfig.max || 10000;
  }

  rangeStepValue(filter) {
    return filter.extraConfig.step || 500;
  }

  get isSeoFriendlyUrl() {
    return (
      this.$route.name === 'JobsBySkillId' ||
      this.$route.name === 'JobsByIndustryId' ||
      this.$route.name === 'JobsByIndustryLocation' ||
      this.$route.name === 'JobsBySkillLocation' ||
      this.$route.name === 'JobsByLocation'
    );
  }

  ///////////////////////////////////////////////////////////////
  formatFilterData() {
    const _this = this;
    let { jobFilterMetaDataVOList } = this.filtersData;
    if (!jobFilterMetaDataVOList) {
      return;
    }

    jobFilterMetaDataVOList = this.filtersData.jobFilterMetaDataVOList.map(
      (filterItem) => {
        if (
          filterItem &&
          (filterItem.displayType === 'select' ||
            _this.isMultiSelectFilter(filterItem.displayType))
        ) {
          if (_this.isCategoryFilter(filterItem.slugAlias)) {
            filterItem.displayList = _this.formatCategoryFilterMetaData(
              filterItem,
            );
            filterItem.valueList = filterItem.displayList;
          } else {
            filterItem.displayList = (filterItem.filterValues || []).map(
              (opt) => opt.label,
            );
            filterItem.valueList = (filterItem.filterValues || []).map(
              (opt) => opt.value,
            );
            if (
              filterItem &&
              _this.isMultiSelectFilter(filterItem.displayType)
            ) {
              filterItem['options'] = _this.multiselectOptions(filterItem);
            }
          }
        }
        if (filterItem.displayType === 'salaryrange') {
          this.salaryDefaultValue = filterItem.defaultValue;
        }
        let defaultVal = _this.getPrevFilterDefaultValue(filterItem);

        filterItem.defaultValue = defaultVal;
        if (filterItem.name === 'JobPosting.SortCriteria') {
          // filterItem.defaultValue = "JobPosting.jobPublishDTTM desc";
          console.log("sorting options");
          const filterValues: any[] = [];
          if(this.isSortByLabelEnabled){
              filterItem.defaultValue = "JobPosting.jobPublishDTTM desc";
              filterValues.push({
                label: filterItem.label,
                sortOrderAsc: false,
                subcategories: null,
                value: "JobPosting.jobPublishDTTM desc"
              });
          }
          filterItem.filterValues.forEach((opt) => {filterValues.push(opt)});

          filterValues.forEach((opt) => {
            _this.sortOptionsList.push({
              sort: _this.getSortFilterExtraConfig(filterItem)[opt.value],
              value: opt.value,
            });
          });
          filterItem.displayList = filterValues.map((opt)=> opt.label);
           
        }
        return filterItem;
      },
    );
    if (jobFilterMetaDataVOList) {
      jobFilterMetaDataVOList.sort((e1, e2) => e1.sequence - e2.sequence);
      _this.filterDataStore = jobFilterMetaDataVOList;
    }
  }

  getSortFilterExtraConfig(filterItem) {
    if (filterItem.extraConfig) {
      return filterItem.extraConfig;
    } else {
      return {
        'JobPosting.jobPublishDTTM': 'desc',
        'JobPosting.jobPayRateHigh': 'desc',
        'JobPosting.startDTTM': 'asc',
      };
    }
  }

  formatCategoryFilterMetaData(filterItem) {
    return filterItem.filterValues.map((opt) => ({
      id: opt.value,
      label: opt.label,
      children: opt.subcategories &&
        opt.subcategories.length &&
        opt.subcategories.map((subOpt) => ({
          id: subOpt.value,
          label: subOpt.label,
        })),
    }));
  }

  isCategoryFilter(slugAlias): boolean {
    return slugAlias === 'category';
  }

  isMultiSelectFilter(displayType): boolean {
    return displayType && displayType === 'multi-select';
  }

  getPrevFilterDefaultValue(newFilterObj) {
    const oldFilterPayload = vxm.jobs.JobListParamsV2;
    if (!oldFilterPayload) {
      return '';
    }
    if (
      newFilterObj.fieldType &&
      newFilterObj.fieldType == '1' &&
      oldFilterPayload.jobParamRequests &&
      oldFilterPayload.jobParamRequests.length > 0
    ) {
      const prevFilterMetaObj = oldFilterPayload.jobParamRequests.filter(
        (filter) =>
          filter.name === newFilterObj.name &&
          filter.fieldType === newFilterObj.fieldType &&
          filter.displayType === newFilterObj.displayType,
      );
      if (
        prevFilterMetaObj &&
        prevFilterMetaObj.length >= 1 &&
        this.isMultiSelectFilter(prevFilterMetaObj[0].displayType)
      ) {
        if (
          prevFilterMetaObj[0].name === 'JobPosting.categoryIds' &&
          prevFilterMetaObj[0].value
        ) {
            if(this.isCategoryFilter(prevFilterMetaObj[0].slugAlias)){
              return JSON.parse(prevFilterMetaObj[0].value).categoryIds;
            }
            return prevFilterMetaObj[0].value
              ? prevFilterMetaObj[0].value.split(/\s*,\s*/)
              : prevFilterMetaObj[0].value;
        }
        return prevFilterMetaObj[0].value
          ? prevFilterMetaObj[0].value.split(/\s*,\s*/)
          : prevFilterMetaObj[0].value;
      } else if (newFilterObj.displayType === 'salaryrange') {
        setTimeout(() => {
          // Validate object to prevent error.
          if (!this.salaryRange && prevFilterMetaObj[0]) {
            let val = prevFilterMetaObj[0].value;
            this.salaryRange = val ? parseInt(val) : 0;
            this.previousSalaryRangeValue = this.salaryRange;
          }
        }, 1);
      } else if (prevFilterMetaObj && prevFilterMetaObj.length >= 1) {
        return prevFilterMetaObj[0].value;
      }
    }

    if (
      newFilterObj.displayType === 'location' &&
      !(this.jobAlertId || this.getJobAlertId || vxm.jobs.FilterForJobAlerts)
    ) {
      this.locationInfo = oldFilterPayload.locationInfo;
    }

    if (newFilterObj.name === 'Sort By' || newFilterObj.fieldType == '2') {
      oldFilterPayload.sortCriteria.sortField = newFilterObj.valueList[0];
      this.sortCriteria.sortOrderAsc =
        newFilterObj.extraConfig[newFilterObj.valueList[0]] === 'asc';
      oldFilterPayload.sortCriteria.sortOrderAsc = this.sortCriteria.sortOrderAsc;
      this.sortCriteria.sortField = oldFilterPayload.sortCriteria.sortField;
      this.JOB_POSTING_INITIAL_SORT = this.sortCriteria.sortField;
      return oldFilterPayload.sortCriteria.sortField;
    }

    if (
      newFilterObj.displayType === 'range' &&
      (this.jobAlertId || this.getJobAlertId || vxm.jobs.FilterForJobAlerts)
    ) {
      var radius = this.locationInfo.radius;
      setTimeout(() => {
        if (!this.range) {
          this.range =
            this.lodash.isEmpty(radius) || radius === undefined
              ? Number(window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.ClientConfigs.companyPreference.companyRadiusMax : vxm.jobs.BrandingInfo.COMPANY_RADIUS_MAX) ||
                DEFAULT_RADIUS_MAX
              : parseInt(radius + '');
        }
      }, 1);
    } else if (newFilterObj.displayType === 'range') {
      var radius = oldFilterPayload.locationInfo.radius;
      setTimeout(() => {
        if (!this.range) {
          this.range =
            this.lodash.isEmpty(radius) || radius === undefined
              ? Number(window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.ClientConfigs.companyPreference.companyRadiusMax : vxm.jobs.BrandingInfo.COMPANY_RADIUS_MAX) ||
                DEFAULT_RADIUS_MAX
              : parseInt(radius + '');
        }
      }, 1);
    }

    if (this.isCategoryFilter(newFilterObj.slugAlias)) {
      return [];
    }

    return '';
  }

  ///////////////////////////////// Job Alert Methods ////////////////////////////////////
  private showJobAlertcard: boolean = false;
  private showJobAlertV2Card: boolean = false;
  private commonJobAlert: CommonJobAlert = new CommonJobAlert();
  private commonJobAlertV2: CommonJobAlertV2 = new CommonJobAlertV2();
  private showJobAlertLink: boolean = false;

  get displayJobAlertCard() {
    let jobAlertMenu: any = 'false';
    if (window.WorkLLama.isConfigJSONEnabled === 'true') {
      jobAlertMenu = vxm.configs.ClientConfigs.slideMenuOptions.find(
        (menu) => menu.sectionKey === 'JOB_ALERTS',
      );
    } else {
      jobAlertMenu = vxm.utility.leftMenuOptions.find(
        (menu) => menu.alias === 'job_alerts',
      );
    }
    return (
      jobAlertMenu && jobAlertMenu.signInVisibility && this.showJobAlertcard
    );
  }

  get isSortByLabelEnabled(){
    return vxm.configs.getGlobalConfigValue('SORT_BY_LABEL_ENABLED');
  }

  toggleJobAlertLink() {
    this.showJobAlertLink = false;
    // Validate UserJobAlerts to proceed.
    if (!(vxm.jobs.UserJobAlerts && vxm.jobs.UserJobAlerts.length)) return;
    vxm.jobs.UserJobAlerts.forEach((item, index) => {
      //vxm.jobs.JobListParams.keywords
      //vxm.jobs.JobListParams.location

      if (this.keywords == '' || this.addressSearchText == '') {
        if (this.keywords == '') {
          if (this.addressSearchText != '') {
            if (
              item.alertConfigDetails.address == this.addressSearchText &&
              item.name === 'All Jobs'
            ) {
              this.showJobAlertLink = true;
            }
          }
        }
        if (this.addressSearchText == '') {
          if (this.keywords != '') {
            if (item.name === this.keywords) {
              this.showJobAlertLink = true;
            }
          }
        }
      } else if (
        item.name === this.keywords &&
        item.alertConfigDetails.address === this.addressSearchText
      )
        this.showJobAlertLink = true;
    });
  }

  isKeywordEntered() {
    if (!this.keywords) return false;
    else return true;
  }

  isSearchTextEntered() {
    if (!this.addressSearchText) return false;
    else return true;
  }

  get keywordsText() {
    if (this.keywords == '') return 'All Jobs';
    else return this.keywords;
  }

  get searchText() {
    return this.addressSearchText;
  }

  get alertText() {
    let text = 'Showing jobs ';
    if (this.keywords != '') {
      text += 'for ' + this.keywords;
    }

    if (this.addressSearchText != '') {
      text += ' in and around ' + this.addressSearchText;
    }
    return text;
  }

  createJobAlert() {
    if (!this.keywords && !this.addressSearchText) {
      //if (!vxm.jobs.JobListParams.keywords && !vxm.jobs.JobListParams.location) {
      this.$wlToastr('error', this.$t('JobAlert_MandatoryTitleOrLocationMsg'), this.$t('JobAlert_JobAlert'));
      return;
    }

    let locale = new Locale();
    locale.city = '';
    locale.state = '';
    locale.country = '';

    let latlong = new Latlong();
    /*if (!this.addressSearchText) {
        latlong.latitude = vxm.jobs.latitude;
        latlong.longitude = vxm.jobs.longitude;
      }*/
    latlong.latitude = vxm.jobs.JobListParams.geoLocation.latLong.latitude;
    latlong.longitude = vxm.jobs.JobListParams.geoLocation.latLong.longitude;
    /*  latlong.latitude = vxm.jobs.JobListParams.geoLocation.latLong.latitude;
    latlong.longitude = vxm.jobs.JobListParams.geoLocation.latLong.longitude;*/

    let geoLocation = new Geolocation();
    geoLocation.requestPref = 'LATLONG';
    geoLocation.locale = this.jobListParams.geoLocation.locale;
    // geoLocation.locale = vxm.jobs.JobListParams.geoLocation.locale;
    geoLocation.latLong = latlong;
    geoLocation.locationType = '';
    geoLocation.locShortName = '';

    let alertConfigDetails = new AlertConfigDetails();
    //alertConfigDetails.textCriteria = this.keywords;
    // alertConfigDetails.address  = this.addressSearchText;
    if (this.keywords) {
      alertConfigDetails.textCriteria = this.keywords;
    }
    alertConfigDetails.address = this.addressSearchText; //vxm.jobs.JobListParams.location;
    alertConfigDetails.latLong = latlong;
    alertConfigDetails.geoLocation = geoLocation;

    let jobAlert = new JobAlertUI();
    //jobAlert.name = this.keywords;
    if (!this.keywords) {
      jobAlert.name = 'All Jobs';
    } else {
      jobAlert.name = this.keywords;
    }
    jobAlert.email = vxm.users.myUserProfile.email;
    jobAlert.fullName =
      vxm.users.myUserProfile.firstName +
      ' ' +
      vxm.users.myUserProfile.lastName;
    jobAlert.companyCode = vxm.jobs.BrandingInfo.companycode;
    jobAlert.alertConfigDetails = alertConfigDetails;
    jobAlert.status = 0;
    jobAlert.isActive = true;
    jobAlert.isValidated = false;
    jobAlert.filter.remoteJobType = [];
    const remoteFilter = this.filterDataStore.find(
      (filter) => filter.name === 'JobPosting.remoteJobType',
    );
    if (remoteFilter && remoteFilter.defaultValue) {
      jobAlert.filter.remoteJobType = remoteFilter.defaultValue;
    }

    if (
      typeof jobAlert.filter.remoteJobType === 'string' &&
      jobAlert.filter.remoteJobType
    ) {
      jobAlert.filter.remoteJobType = [jobAlert.filter.remoteJobType];
    }
    this.commonJobAlert.jobAlert = jobAlert;
    this.saveJobAlert();
  }

  validateJobAlert(): boolean {
    return true;
  }
  getCompanyDistanceUnits(): string {
    const temp = vxm.jobs.getCompanyDistanceUnit.toLowerCase();
    const preferredUnit = temp.charAt(0).toUpperCase() + temp.slice(1);
    return this.getTranslatedValue(`distance.units.${temp}`, preferredUnit);
  }

  saveJobAlert() {
    if (this.validateJobAlert()) {
      vxm.jobs.createCommonJobAlert(this.commonJobAlert).then((res) => {
        if (res.success === true) {
          this.commonJobAlert.jobAlert.id = res.jobAlertId;
          vxm.jobs.UserJobAlerts.push(this.commonJobAlert.jobAlert);
          this.toggleJobAlertLink();
          vxm.users.Rudderstack.trackEvent("Job Alert Created", {
            jobAlertId: res.jobAlertId,       
          jobAlertFrequency : this.jobAlertFrequency
          });
          this.$wlToastr('success', '', this.getJobAlertSuccessMessage());
          this.commonJobAlert = new CommonJobAlert();
        } else {
          this.$wlToastr('error', res.errorMessage, this.$t('JobAlert_JobAlert').toString());
        }
      });
    }
  }

  getJobAlertSuccessMessage() {
    if (vxm.users.isLoggedIn) {
      return this.$t('jobalert-created-success-message');
    }
    return this.$t('jobalert-created-anon-success-message');
  }

  ///////////////////////////////////////////////////////////////////////
  // Job alert enhancement
  ///////////////////////////////////////////////////////////////////////
  private jobAlertName: string = 'My saved alert';
  private jobAlertFrequency: string = '01';
  private jobAlertEmail: string = '';
  createJobAlertV2() {
    this.notificationMap();
    if (!this.jobAlertName) {
      //if (!vxm.jobs.JobListParams.keywords && !vxm.jobs.JobListParams.location) {
      this.$wlToastr('error', this.$t('JobAlert_MandatoryJobAlertNameMsg').toString(), this.$t('JobAlert_JobAlert').toString());
      return;
    }
    if (!this.isLoggedIn && !this.jobAlertEmail) {
      this.$wlToastr('error', this.$t('JobAlert_MandatoryEmailMsg').toString(), this.$t('JobAlert_JobAlert').toString());
      return;
    }
    if (!this.jobAlertFrequency) {
      //if (!vxm.jobs.JobListParams.keywords && !vxm.jobs.JobListParams.location) {
      this.$wlToastr('error', this.$t('JobAlert_MandatoryFrequencyMsg').toString(), this.$t('JobAlert_JobAlert').toString());
      return;
    }

    let locale = new Locale();
    locale.city = '';
    locale.state = '';
    locale.country = '';

    let jobAlertConfigDetails = this.prepareRequestPayloadV2();

    //jobAlertConfigDetails.address = this.addressSearchText; //vxm.jobs.JobListParams.location;

    let jobAlert = new JobAlertV2();
    //jobAlert.email = vxm.users.myUserProfile.email;
    //jobAlert.fullName = vxm.users.myUserProfile.firstName + ' ' + vxm.users.myUserProfile.lastName;
    //jobAlert.companyCode = vxm.jobs.BrandingInfo.companycode;
    jobAlert.jobAlertConfigDetails = jobAlertConfigDetails;
    jobAlert.status = 0;
    jobAlert.jobAlertFrequency = this.jobAlertFrequency;
    jobAlert.name = this.jobAlertName;
    jobAlert.email = this.jobAlertEmail;
    jobAlert.notificationType.sms = this.jobAlertIsSms;
    jobAlert.notificationType.email = this.jobAlertIsEmail;
    jobAlert.companyCode = vxm.jobs.BrandingInfo.companycode;

    this.commonJobAlertV2.jobAlert = jobAlert;
    vxm.jobs.createCommonJobAlertV2(this.commonJobAlertV2).then((res) => {
      const data = res ? res.data : {};
      if (data.success === true) {
        this.jobAlertIsSms = false;
        this.jobAlertIsEmail = true;
        this.linkCopied = false;
        if (!this.isLoggedIn) {
          this.$modal.show(
            ConfirmationModalV2,
            {
              header: this.$t('JobAlert_AnonAlertCreatedSuccessfulyHeader'),
              subText: this.$t('JobAlert_AnonAlertCreatedSuccessfulySubHeader'),
              subHeader: this.$t('JobAlert_AnonAlertCreatedSuccessfulyNextSteps'),
              hideOkButton: true,
              subBody: this.$t('JobAlert_AnonAlertCreatedSuccessfulySubBody', { alertName: this.jobAlertName.bold() }),
              body: this.$t('JobAlert_AnonAlertCreatedSuccessfulyBody', { email: this.jobAlertEmail.bold() }),
              hideCancelButton: true,
            },
            {
              height: 'auto',
              clickToClose: false,
            },
          );
        }

        this.commonJobAlertV2.jobAlert.id = data.jobAlertId;
        vxm.users.Rudderstack.trackEvent('Job Alert Created', {
          jobAlertId: data.jobAlertId,       
          jobAlertFrequency : this.jobAlertFrequency
        });
        this.$wlToastr('success', '', this.$t('jobalert-saved-success-message'));
        if (this.isLoggedIn) {
          // const respPromise: any = vxm.users.saveUserProfile({
          //   userProfile: this.userProfile,
          //   isPartofRegistration: false,
          // });
          const resp = vxm.notificationpreference.updateUserNotificationPreferences(this.notificationPreferences);
          // this.userProfile = vxm.users.myUserProfile;
          this.notificationPreferences = vxm.notificationpreference.userNotificationPreferences;
          this.notificationAssign();
        }

        this.jobAlertName = 'My Saved Alert';
        this.jobAlertEmail = '';
        this.jobAlertIsSms = false;
        this.jobAlertIsEmail = true;
        this.jobAlertFrequency = '01';
        this.showEditJobAlertModal = false;
      } else {
        this.$wlToastr('error', data.errorMessage, this.$t('JobAlert_JobAlert').toString());
      }
    });
  }

  prepareRequestPayloadV2(): JobAlertConfigDetailsV2 {
    let jobSearchRequestPayload = new JobAlertConfigDetailsV2(); //using this object to keep the previous values, (because is possible that "Jobs per Page" change the default value)
    let filterPayload: FilterModel[] = [];
    this.filterDataStore.forEach((element) => {
      if (element.name && element.name === 'JobPosting.searchField') {
        this.keywords = element.defaultValue;
      }
      if (element.fieldType === 1) {
        let filterValue;
        if (this.isCategoryFilter(element.slugAlias)) {
          filterValue =
            element.defaultValue && element.defaultValue.length
              ? JSON.stringify({ categoryIds: element.defaultValue })
              : null;
        } else {
          filterValue = element.defaultValue
            ? Array.isArray(element.defaultValue)
              ? element.defaultValue.toString()
              : element.defaultValue
            : null;
        }
        // Remove (+) sing from payment rate.
        if ('JobPosting.jobPayRateHigh' === element.name && filterValue) {
          filterValue = filterValue.replaceAll('+', '');
        }
        let obj = this.createFilterModel(
          element.name,
          element.displayType,
          element.fieldType,
          filterValue,
          element.slugAlias,
        );
        if (filterValue) {
          filterPayload.push(obj);
        }
      }
    });

    jobSearchRequestPayload.jobParamRequests = filterPayload;
    if (!this.locationInfo.location) {
      this.locationInfo.latLong.latitude = vxm.jobs.latitude;
      this.locationInfo.latLong.longitude = vxm.jobs.longitude;
    }

    jobSearchRequestPayload.locationInfo = this.locationInfo;
    if (this.sortCriteria && !this.sortCriteria.sortField) {
      this.sortCriteria.sortField = this.JOB_POSTING_INITIAL_SORT;
    }
    jobSearchRequestPayload.sortCriteria = this.sortCriteria;
    jobSearchRequestPayload.locationInfo.radius = this.range;
    if (this.isRangeSelectorDisabled) {
      jobSearchRequestPayload.locationInfo.radius = DEFAULT_RADIUS;
    }

    // vxm.jobs.setFilterRadius(this.range);
    //if(this.previousRadius) {
    //  this.createFilterModel('Facility.radius', 'range', '1', this.range);
    //}
    return jobSearchRequestPayload;
  }

  createFilterModel(
    name,
    displayType,
    fieldType,
    filterValue,
    slugAlias,
    label = null,
  ): FilterModel {
    let obj: FilterModel = {
      name,
      displayType,
      fieldType,
      value: filterValue,
      slugAlias,
      //label,
    };
    return obj;
  }

  clearFilters() {
    this.singleSelectFilter = [];
    this.multiSelectFilter = [];
    this.resetMapViewPageNumber();
    setTimeout(
      (this_) => {
        this_.addressSearchText = '';
        this_.locationInfo.location = '';
        this_.locationParser = '';
        if (this_.$refs.address_filter && this_.$refs.address_filter[0]) {
          this_.$refs.address_filter[0].update('');
        }
        if (this_.$refs.address_filter_2 && this_.$refs.address_filter_2[0]) {
          this_.$refs.address_filter_2[0].update('');
        }
        this.onAddressTextChange('');
      },
      1,
      this,
    );
    this.locationInfo.location = '';
    this.panelBodyVisibility = false;
    this.jobListParams.resultPage = 1;
    this.locationInfo.locShortName = '';
    this.locationInfo.locationType = '';
    this.locationInfo.latLong.latitude = 0.0;
    this.locationInfo.latLong.longitude = 0.0;
    this.locationInfo.radius =
      Number(window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.ClientConfigs.companyPreference.companyRadiusMax : vxm.jobs.BrandingInfo.COMPANY_RADIUS_MAX) || 3250;
    vxm.jobs.setFilterRadius(this.locationInfo.radius);

    // To default the location
    if (!this.locationInfo.location) {
      this.locationInfo.latLong.latitude = vxm.jobs.latitude;
      this.locationInfo.latLong.longitude = vxm.jobs.longitude;
    }
    this.jobListParams.resultSize = 10;
    this.sortCriteria.sortField = this.JOB_POSTING_INITIAL_SORT;
    this.sortCriteria.sortOrderAsc =
      this.sortCriteria.sortField === 'JobPosting.jobPayRateHigh' ||
      this.sortCriteria.sortField === 'JobPosting.jobPublishDTTM'
        ? false
        : true;
    this.addressSearchText = '';
    this.previousSalaryRangeValue = 0;
    this.previousRadius = DEFAULT_RADIUS;
    this.range = Number(window.WorkLLama.isConfigJSONEnabled === 'true' ? vxm.configs.ClientConfigs.companyPreference.companyRadiusMax : vxm.jobs.BrandingInfo.COMPANY_RADIUS_MAX) || 3250;
    this.previousRadius = this.range;
    this.panelBodyVisibility = false;
    this.isRangeSelectorDisabled = false;
    this.salaryPanelBodyVisibility = false;
    this.salaryRange = 0;

    if (this.filterDataStore) {
      this.filterDataStore = this.filterDataStore.map((filter) => {
        if (filter.fieldType && filter.fieldType === 2) {
          filter.defaultValue = this.JOB_POSTING_INITIAL_SORT;
          if(this.isSortByLabelEnabled ){
            filter.defaultValue = "JobPosting.jobPublishDTTM desc";
           }
        } else if (this.isMultiSelectFilter(filter.displayType)) {
          filter.defaultValue = [];
        } else filter.defaultValue = '';

        return filter;
      });
    }
    this.resetPageNumber();
    this.filterJobs();
  }

  destroyed() {
    vxm.jobs.setSearchFilterObj({
      ...vxm.jobs.searchFilterObj,
      categories: [],
    });
  }

  MobileViewFilter() {
    for (var i = 0; i < this.filterDataStore.length; i++) {
      this.filterDataStore[i].defaultValue = [];
      if (this.multiSelectFilter[i]) {
        for (var j = 0; j < this.multiSelectFilter[i].length; j++) {
          this.filterDataStore[i].defaultValue.push(
            this.multiSelectFilter[i][j].value,
          );
        }
      } else if (
        typeof this.singleSelectFilter[i] !== 'undefined' &&
        this.singleSelectFilter[i].value
      ) {
        this.filterDataStore[i].defaultValue = this.singleSelectFilter[i].value;
      }
    }
    this.applyBeforeFilter();
  }

  applyBeforeFilter() {
    this.showJobAlertV2Card = true;
    this.resetPageNumber();
    this.filterJobs();
  }

  resetPageNumber() {
    const jobListParams = vxm.jobs.JobListParamsV2;
    jobListParams.pageNumber = 1;
    this.resetMapViewPageNumber();
  }

  resetMapViewPageNumber() {
    try {
      const jobPager = vxm.jobs.MapViewJobPager;
      vxm.jobs.setMapViewJobListings([]);
      jobPager.resultPage = 1;
    } catch (exc) {
      console.log(exc);
    }
  }

  get isDistanceUnitKm() {
    return (
      vxm.jobs.getCompanyDistanceUnit == 'Kilometers' ||
      vxm.jobs.getCompanyDistanceUnit == 'kilometers'
    );
  }

  includeInParams(filterName: string) {
    console.debug('checking', filterName);
    const excludedList = ['Facility.location', 'Facility.radius'];
    return filterName && !excludedList.includes(filterName);
  }

  async loadOptions({ action /*, callback*/ }) {
    //used by treeselect field
    if (action === LOAD_ROOT_OPTIONS) {
      return;
    }
  }
  toggleShowEditJobAlertModal() {
    this.showEditJobAlertModal = !this.showEditJobAlertModal;
    if (this.showEditJobAlertModal && !this.jobAlertName) {
      //this.jobAlertName = ;
    }
  }

  // Copy current url method
  copyCurrentUrl() {
    if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
      let copyReturn = navigator.clipboard.writeText(window.location.href);
      this.linkCopied = true;
      return copyReturn;
    }

    return false;
  }

  handleCopyUrlSuccess(e) {
    this.$wlToastr('info', this.$t('search-box-link-copied'), 'Job Alerts');
  }
  handleCopyUrlError(e) {
    console.log(e);
    this.$wlToastr('info', this.$t('referrals.unable.to.copy'), 'Job Alerts');
  }
  get UserTOSAgreementText() {
    const customTOStext = vxm.users.getUserLang == 'fr'  ? 
    vxm.configs.getGlobalConfigValue('USER_TOS_AGREEMENT_TEXT_FR') 
    :vxm.configs.getGlobalConfigValue('USER_TOS_AGREEMENT_TEXT');
    if (customTOStext) return customTOStext
      .replace(/{companyName}/g, vxm.utility.companyName)
      .replace(/{termsOfServiceURL}/g, this.termsOfServiceURL)
      .replace(/{privacyPolicyURL}/g, this.privacyPolicyURL);

    return this.$t('signup.terms.services', {
      termsOfServiceURL: this.termsOfServiceURL,
      privacyPolicyURL: this.privacyPolicyURL,
      companyName: vxm.utility.companyName
    })
  }
  get termsOfServiceURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_TERMS_OF_SERVICE_END_POINT_URL',
      'termsLink',
    );
  }
  get privacyPolicyURL() {
    return vxm.configs.getCompanyPreference(
      'CANDIDATE_PORTAL_PRIVACY_POLICY_END_POINT_URL',
      'privacyLink',
    );
  }

  gdpr(gdprObj: any) {
    this.gdprObj = gdprObj;
  }

  get isGDPREnabled () {
    return !this.isLoggedIn && vxm.configs.getGlobalConfigValue('IS_GDPR_ENABLED');
  }
  
  get isSubmittJobAlertDisabled() {
    if(!this.jobAlertIsEmail && !this.jobAlertIsSms) return true;
    if(this.isLoggedIn) return false;
    if (this.isGDPREnabled && (!this.gdprObj.tosEmailFlag || !this.gdprObj.marketingEmailFlag)) {
      return true;
    } else if (this.isGDPREnabled && (this.gdprObj.tosEmailFlag ||this.gdprObj.marketingEmailFlag )) {
      false;
    }
    return false;
  }

}
